<script lang="ts" setup>
import {generalService} from '~/api/service/general.service'
import FeedbackFloatingButton from '~/components/@pages/home/FeedbackFloatingButton.vue'
import NoticeBar from '~/components/@pages/home/NoticeBar.vue'
import DefaultFooter from '~/components/footer/DefaultFooter.vue'
import ModalBackground from '~/components/modal/ModalBackground.vue'
import SearchModal from '~/components/modal/SearchModal.vue'
import LaptopSideNavigation from '~/components/navigation/laptop/LaptopSideNavigation.vue'
import MobileTopNavigation from '~/components/navigation/mobile/MobileTopNavigation.vue'
import SideNavigation from '~/components/navigation/SideNavigation.vue'
import TopNavigation from '~/components/navigation/TopNavigation.vue'
import Toast from '~/components/toast/Toast.vue'

const route = useRoute()

const showSideBar = ref(false)
const changeShowSideBar = (value = !showSideBar.value) => {
  showSideBar.value = value
}

watch(() => route.fullPath, () => {
  changeShowSideBar(false)
})

const {data: isDelayed} = generalService.useGetDelayCheck()

const desktopPaddingTop = computed(() => {
  return isDelayed.value ? '6.5rem' : '4rem'
})

const mobilePaddingTop = computed(() => {
  return isDelayed.value ? '5.5rem' : '3rem'
})

const navTopPosition = computed(() => {
  return isDelayed.value ? '40px' : '0'
})
</script>

<template>
  <Toast/>
  <ModalBackground>
    <template #modal>
      <SearchModal class="search-modal"/>
    </template>
  </ModalBackground>
  <NoticeBar v-if="isDelayed"/>
  <TopNavigation class="top-navigator desktop"/>
  <MobileTopNavigation
    class="top-navigator mobile"
    :show-side-bar="showSideBar"
    @update:show-side-bar="(state) => {
      changeShowSideBar(state)
    }"
  />
  <div class="layout-body">
    <div
      class="sidebar-container"
      :class="{show: showSideBar}"
    >
      <SideNavigation class="sidebar-navigator desktop"/>
      <LaptopSideNavigation class="sidebar-navigator laptop"/>
    </div>
    <BackgroundImage/>
    <div class="content-cont">
      <slot/>
      <div class="flex-1"/>
      <DefaultFooter/>
    </div>
  </div>
  <FeedbackFloatingButton/>
  <Credit/>
</template>

<style lang="scss" scoped>
.search-modal {
  @apply top-[20vh];

  @include sm {
    @apply top-4;
  }
}

.top-navigator {
  //@apply fixed top-0 z-[5000];
  @apply fixed z-[5000];
  top: v-bind(navTopPosition);

  &.desktop {
    @include sm {
      display: none;
    }
  }

  &.mobile {
    display: none;

    @include sm {
      display: flex;
    }
  }
}

.layout-body {
  @apply flex;
  //padding-top: 72px;

  padding-top: v-bind(desktopPaddingTop);
  padding-left: 288px;
  min-height: 100vh;

  transition: padding 0.3s ease;

  @include lg {
    padding-left: 72px;
    &:has(.sidebar-container:hover) {
      padding-left: 288px;
    }
  }

  @include sm {
    /* iOS safe area 포함한 모바일 padding-top */
    padding-top: calc(v-bind(mobilePaddingTop) + env(safe-area-inset-top, 0px));
    padding-left: 0;
    position: relative;
    &:has(.sidebar-container:hover) {
      padding-left: 0;
    }
  }

  .sidebar-container {
    position: fixed;
    top: v-bind(desktopPaddingTop);
    left: 0;
    width: 288px;
    flex-shrink: 0;
    z-index: 1000;
    height: 100%;
    overflow-x: hidden;

    @include lg {
      width: 72px;
      transition: width 0.3s ease;
      @include background-blur(16px);
      &:hover {
        width: 288px;

        & .sidebar-navigator {
          &.desktop {
            display: block;
          }

          &.laptop {
            display: none;
          }
        }
      }
    }

    @include sm {
      @apply hidden;
      &.show {
        @apply block w-full h-full z-[6000] backdrop-blur-lg bg-background/20;
        /* iOS safe area 포함 */
        top: calc(v-bind(mobilePaddingTop) + env(safe-area-inset-top, 0px));

        &:hover {
          @apply w-full;
        }
      }
    }

    .sidebar-navigator {
      &.laptop {
        display: none;
      }

      @include lg {
        &.desktop {
          display: none;
        }

        &.laptop {
          display: block;
        }
      }

      @include sm {
        &.desktop {
          @apply text-sm w-[calc(100%-1rem)] top-0;
          display: block;
        }

        &.laptop {
          display: none;
        }
      }
    }
  }

  .content-cont {
    // poly, base
    // @apply p-4 w-full min-w-0 flex flex-col;
    padding: 32px 64px 50px 64px;
    min-width: 0;
    width: 100%;

    @include md {
      padding: 32px 32px 64px;
    }

    @include sm {
      padding: 16px;
      /* iOS safe area 대응 - 하단 홈 인디케이터 영역 */
      padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    }
  }
}
</style>